import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { isEmpty, take, map } from 'lodash';
import { Paper, FontIcon, Divider, ListItem } from 'material-ui';

import { iconSelect } from 'utils/iconSelect';
import { dateTime } from 'utils/dateTools';
import { fetchUserFiles } from 'actions/Files';
import KFlatButton from 'components/KJRN/KFlatButton';
import styles from 'styles/TBenefits';
import TLoading from './TLoading';
import TMessage from './TMessage';

const TFiles = () => {
  const dispatch = useDispatch();
  const { loaded, files, documentTypesById } = useSelector(state => state.FileReducer);

  useEffect(() => {
    dispatch(fetchUserFiles());
  }, [dispatch]);

  if (!loaded) return <TLoading />;

  if (isEmpty(files)) {
    return (
      <TMessage message="tile.files.empty">
        <KFlatButton
          style={styles.actionButton}
          onClick={() => dispatch(push('/files'))}
          containerStyle={styles.action}
          label={<FormattedMessage id="tile.files.goto" />}
        />
      </TMessage>
    );
  }

  const gotoFiles = () => {
    window.scrollTo({ top: 0 });
    dispatch(push('/files'));
  };

  return (
    <div style={styles.container}>
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        <Paper>
          {map(take(files, 5), x => (
            <div key={x.DocumentId}>
              <ListItem
                style={{ wordBreak: 'break-all' }}
                leftIcon={<FontIcon className="material-icons">{iconSelect(x.Extension)}</FontIcon>}
                primaryText={`${x.Name}${x.Extension}`}
                secondaryText={`${documentTypesById[x.ObjectDocumentType] && documentTypesById[x.ObjectDocumentType].Name} ${dateTime(x.AddDate)}`}
                disabled
              />
              <Divider />
            </div>
          ))}
        </Paper>
      </div>
      <KFlatButton
        style={styles.actionButton}
        onClick={gotoFiles}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.files.goto" />}
      />
    </div>
  );
};

export default TFiles;



// WEBPACK FOOTER //
// ./src/containers/tiles/TFiles.js